import axios from "axios";

import type { tBooking } from "../types";

export const createBooking = async (data: tBooking) => {
  return await axios.post(
    `${process.env.REACT_APP_BOOKING_INVOKE_URL}/bookings/create`,
    data,
  );
};
